export default function createKey(value: string, before = "", after = "") {
  try {
    if (!before) {
      return `${value}`.replace(/[^a-zA-Z0-9]/g, "_") + after;
    }
    if (!after) {
      return before + "_" + `${value}`.replace(/[^a-zA-Z]/g, "_");
    }
    return before + "_" + `${value}`.replace(/[^a-zA-Z]/g, "_") + after;
  } catch (e) {
    console.log("🚀 ~ createKey ~ e:", e);
    return value;
  }
}
